import { useEffect } from "react";

import { resolveInitialLocale } from "@/utils/locale/initial-locale";
import { redirectUnsupportedLocale } from "@/utils/locale/redirect-unsupported-locale";

export interface AuthorizationParamsLike {
  ui_locales?: string | null;
  lang?: string | null;
  [key: string]: string | null | undefined;
}

/**
 * Resolves the initial auth locale from Auth0 authorization parameters and
 * redirects to the CIAM error page when no supported locale can be derived.
 *
 * Call once at the screen boundary. Returns null while redirecting so the
 * screen can stop rendering.
 */
export function useInitialLocale(
  authorizationParams: AuthorizationParamsLike | null | undefined,
): string | null {
  const uiLocales = authorizationParams?.ui_locales ?? null;
  const lang = authorizationParams?.lang ?? null;
  const initialLocale = resolveInitialLocale({ uiLocales, lang });

  useEffect(() => {
    if (initialLocale === null) {
      redirectUnsupportedLocale({ uiLocales, lang });
    }
  }, [initialLocale, uiLocales, lang]);

  return initialLocale;
}
